<template>
  <div class="col">
    <div class="card">
      <router-link :to="`/terapeutas/${therapist.id}`" class="router-link" >
        <img :src="therapistPhoto" 
          class="card-img-top" 
          alt="..." 
          width="160px;"
        >
        <div class="card-body">
          <h6 class="card-title">{{ therapist.name }}</h6>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import noPhoto from '../assets/images/no-photo.png';
import * as therapistsApiClient from "@/js/therapistsApiClient";

  export default {
    name: 'TherapistCard',
    props: {
      therapist: Object
    },
    data() {
      return {
        showModal: false,
        therapistPhoto: this.therapist.photoUrl || noPhoto,
      }
    },
    methods: {
      async deleteTherapist() {
        if (this.therapist.id) {
          await therapistsApiClient.deleteTherapist(this.therapist.id);
          this.$emit("therapistDeleted", {id: this.therapist.id});
        }
      }
    },
    watch: {
      $route:  {
        immediate: true,
        handler: function(newVal) {
          this.showModal = newVal.meta && newVal.meta.showModal;
        }
      }
    }
  }
</script>

<style scoped>

.card {
  margin: 10px;
  width: 180px;
  height: 320px;
}

.router-link {
  text-decoration: none; 
  color: inherit;
}

.card-body h6 {
  font-size: 1em;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
}

.card-img-top {
  object-fit: cover; 
  height: 220px; 
}

</style>
